import React from "react";


export default function Footer() {

    return (
        <>
        <style>

            {`
                .emoji {
                    position: relative;
                    // cursor: help;
                }
                
                .emoji:hover::before {
                    content: attr(data-title);
                    position: absolute;
                    bottom: 110%;
                    left: 50%;
                    transform: translateX(-50%);
                    padding: 4px 8px;
                    background-color: #4a5568;
                    color: #fff;
                    font-size: 12px;
                    line-height: 1;
                    border-radius: 4px;
                    white-space: nowrap;
                }
  
              
            `}
        </style>
            <div className="max-w-screen-lg mx-auto flex flex-col justify-center w-full">
                <div className='py-6 text-sm font-bold text-center text-gray-400'>
                    <div>
                        My Portfolio was made with 👨‍💻 🤔 ❤️ 🎶 ☕
                    </div>
                    <div class="relative">
                        My portfolio was made in town
                        <span class="emoji" data-title="Lampung">🐘</span>
                    </div>
                </div>
            </div>
        </>
    )
}
